import React from 'react';
import { useParams } from 'react-router-dom';

const PlaceholderPage = () => {
  const params = useParams();

  // Capitalize the first letter of a string
  const capitalize = (s) => s && s.charAt(0).toUpperCase() + s.slice(1);

  // Get the last part of the URL path for the title
  const title = Object.values(params)
    .pop() // Get the last parameter
    .split('-') // Split by hyphen
    .map(capitalize) // Capitalize each word
    .join(' '); // Join with spaces

  return (
    <div className="p-8 text-center">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">
        {title}
      </h1>
      <p className="text-lg text-gray-600">
        This is a placeholder page. The detailed content and workflow configuration for this agent are under development.
      </p>
    </div>
  );
};

export default PlaceholderPage;